import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentTokenValue: string = this.authService && this.authService.currentTokenValue;

    if (currentTokenValue) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentTokenValue}`
        }
      });
    }

    return next.handle(request);
  }
}
